import { cn } from '@/lib/utils'

interface BadgeProps {
  variant?: 'primary' | 'success' | 'warning' | 'neutral' | 'error'
  children: React.ReactNode
  className?: string
}

export function Badge({
  variant = 'primary',
  children,
  className,
}: BadgeProps) {
  const variants = {
    primary: 'bg-primary/10 text-[var(--color-text-primary)] border-primary/30',
    success:
      'bg-[var(--color-success-bg)] text-[var(--color-success-text)] border-[var(--color-success-border)]',
    warning:
      'bg-[var(--color-warning-bg)] text-[var(--color-warning-text)] border-[var(--color-warning-border)]',
    neutral:
      'bg-[var(--color-control-surface)] text-[var(--color-text-tertiary)] border-[var(--color-border)]',
    error:
      'bg-[var(--color-error-bg)] text-[var(--color-error-text)] border-[var(--color-error-border)]',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-caption font-bold tracking-wide',
        'backdrop-blur-sm transition-colors duration-200 ease-brisk',
        variants[variant],
        className,
      )}
    >
      {children}
    </span>
  )
}
